<template>
  <div class="panel granary-panel">
    <div class="chart-box">
      <div ref="chart" class="chart"></div>
    </div>
  </div>
</template>

<script>
import { loadChart } from "../charts/bar_common_4_Data";

export default {
  props: {
    datas: {
      type: Array,
      default: () => {
        return [
          {
            name: "北京",
            value: 274
          },
          {
            name: "天津",
            value: 64
          },
          {
            name: "河北",
            value: 382
          },
          {
            name: "山西",
            value: 145
          },
          {
            name: "内蒙古",
            value: 37
          },
          {
            name: "辽宁",
            value: 209
          },
          {
            name: "吉林",
            value: 109
          },
          {
            name: "黑龙江",
            value: 164
          },
          {
            name: "上海",
            value: 890
          },
          {
            name: "江苏",
            value: 417
          },
          {
            name: "浙江",
            value: 600
          },
          {
            name: "安徽",
            value: 288
          },
          {
            name: "福建",
            value: 317
          },
          {
            name: "江西",
            value: 409
          },
          {
            name: "山东",
            value: 505
          },
          {
            name: "河南",
            value: 859
          },
          {
            name: "湖北",
            value: 422
          },
          {
            name: "湖南",
            value: 844
          },
          {
            name: "广东",
            value: 9530
          },
          {
            name: "广西",
            value: 2814
          },
          {
            name: "海南",
            value: 1873
          },
          {
            name: "重庆",
            value: 341
          },
          {
            name: "四川",
            value: 707
          },
          {
            name: "贵州",
            value: 696
          },
          {
            name: "云南",
            value: 991
          },
          {
            name: "西藏",
            value: 3
          },
          {
            name: "陕西",
            value: 138
          },
          {
            name: "甘肃",
            value: 46
          },
          {
            name: "青海",
            value: 67
          },
          {
            name: "宁夏",
            value: 60
          },
          {
            name: "新疆",
            value: 33
          }
        ];
      }
    },
    unit: {
      type: String,
      default: "人数"
    },
    haszoom: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    sname: {
      type: String,
      default: "采购商"
    }
  },

  watch: {
    datas: {
      handler() {
        this.getData();
      },
      immediate: true
    }
  },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.chart);
  },
  methods: {
    getData() {
      if (!this.chart) {
        if (this.datas && this.datas.length > 0) {
          setTimeout(() => {
            this.getData();
          }, 500);
        }
        return;
      }
      const xline = this.datas.map((e, i) => {
        if (i % 2 !== 0) {
          return "\n" + e.name;
        }
        return e.name;
      });
      if (xline) {
        loadChart(
          this.chart,
          this.datas,
          xline,
          this.unit,
          this.haszoom,
          this.sname,
          this.title
        );
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.panel
  height 100%
  width 100%
  .chart-box
    width 100%
    height 100%
</style>
